export default __webpack_public_path__ + "static/media/InsideStomach_07.daef4620.png";